import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "../../../core/Icon";
export const Header = (props) => {
    const { title, role, editUrl, refno } = props;
    return React.createElement("div", { className: "ed-hd" },
        React.createElement("div", null,
            React.createElement("h1", { className: "ed-title" }, title),
            React.createElement("div", { className: "ed-refno" },
                "Jednac\u00ED \u010D\u00EDslo aukce ",
                refno,
                " ")),
        role == 'admin' &&
            React.createElement(Link, { to: editUrl, className: "ed-edit" },
                "Editovat",
                React.createElement(Icon, { c: ['edit-page', 24, 24] })));
};
